module.exports = __webpack_public_path__ + "static/media/Ashmayu_Full_B.dc9393fe.png";